<!--
 * @Author: guozhenqiang 15138913894@163.com
 * @Date: 2023-03-01 17:39:18
 * @LastEditors: guozhenqiang 15138913894@163.com
 * @LastEditTime: 2023-04-26 11:28:52
 * @FilePath: \baichuan-website\src\component\nav.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
   <div class="nav_banner">
      <div class="about_nav" >
      <div
        :class="['item',{selected_color:index === selected}]"
        v-for="(item,index) in navData"
        :key="item.name"
        @click="getActive(index,item.path)"
        >
        {{ item.name }}
      </div>

      </div>
    </div>
</template>
<script>
export default {
  props: {
    navData: Array,
    defalutKey:Number
  },
  data() {
    return {
      selected: 0,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.selected = Number(this.$route.params.id);
    }
  },
  methods: {
    getActive(i,path) {
      this.selected = i;
      this.$emit('selectFun', i);
    },
  }
};
</script>
<style scoped>
.nav_banner{
  width: 100%;
  /* height: 70px; */
  background: #fff;
  box-shadow: 0px 10px 20px 0px rgba(188,195,206,0.10);
}
.about_nav{
  /* width: 100%; */
  width: 1200px;
  margin: 0 auto;
  /* height: 70px; */
  display: flex;
  justify-content: center;
}
.item{
  padding: 20px;
  /* height: 70px;
  line-height: 70px; */
  margin-right: 51px;
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #4c5360;
  letter-spacing: 1.6px;
  position: relative;
  cursor: pointer;
}
.item:hover{
  color: #01A9BB;
}
.selected_color{
 color: #01A9BB;
 border-bottom: 2px solid #01A9BB;
}
</style>




// WEBPACK FOOTER //
// src/component/nav.vue